import { offsetReasons } from './slice'

// Get All
export const {
  resetOffsetReasonListState,
  setOffsetReasonList,
  setOffsetReasonLoading
} = offsetReasons.actions
